import React from "react";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
import clientStore, { rrfProps } from "./store";
import Client from "./client";
import { Provider } from "react-redux";

const ClientWrapper = (props) => (
  <Provider store={clientStore}>
    <ReactReduxFirebaseProvider {...rrfProps}>
      <Client {...props} />
    </ReactReduxFirebaseProvider>
  </Provider>
);

export default ClientWrapper;
